<template>
	<div class="content-wrapper">
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item">
					<a href="#">
						<i class="fa fa-home"></i>
						Dashboard
					</a>
				</li>
				<li class="breadcrumb-item active">Sessions</li>
				<li class="breadcrumb-item active">Summary</li>
				<li class="breadcrumb-right">
					<select class="form-control form-control-sm" v-model="report.session_log_id"
						@change="getSessionReport()">
						<option v-for="(session_log, key) in session_logs" :key="key"
							:value="session_log.session_log_id">
							{{ $formatDate(session_log.start, 'india') }} - {{ $formatDate(session_log.end, 'india') }}
						</option>
					</select>
				</li>
				<li class="breadcrumb-right">
					<a target="_blank"
						:href="$store.getters.pdfUrl + 'turn_arround_time?session_log_id=' + report.session_log_id"
						class="btn btn-sm btn-success">
						<i class="fa fa-download"></i> Turnaround Time
					</a>
					<button @click="exportAllTabsToExcel" class="btn btn-sm btn-info" :disabled="!report.session_log_id"
						v-can="'sessions.download_report'">
						<i class="fa fa-file-excel"></i> Download Session Report
					</button>
				</li>
			</ol>
		</nav>
		<section class="content">
			<div class="container-fluid">
				<div class="row justify-content-md-center">
					<div class="col-sm-12">
						<div class="card card-dark card-tabs">
							<div class="card-header p-0">
								<ul class="nav nav-tabs" id="custom-tabs-two-tab" role="tablist">
									<li class="nav-item">
										<a class="nav-link active px-2 py-3" id="page1-tab" data-toggle="pill"
											href="#page1" role="tab" aria-controls="page1"
											aria-selected="true">Summary</a>
									</li>
									<li class="nav-item">
										<a class="nav-link px-2 py-3" id="page2-tab" data-toggle="pill" href="#page2"
											role="tab" aria-controls="page2" aria-selected="false">BuyIn</a>
									</li>
									<li class="nav-item">
										<a class="nav-link px-2 py-3" id="page3-tab" data-toggle="pill" href="#page3"
											role="tab" aria-controls="page3" aria-selected="false">CashOut</a>
									</li>
									<li class="nav-item">
										<a class="nav-link px-2 py-3" id="page4-tab" data-toggle="pill" href="#page4"
											role="tab" aria-controls="page4" aria-selected="false">Deposit</a>
									</li>
									<li class="nav-item">
										<a class="nav-link px-2 py-3" id="page5-tab" data-toggle="pill" href="#page5"
											role="tab" aria-controls="page5" aria-selected="false">Withdraw</a>
									</li>
									<li class="nav-item">
										<a class="nav-link px-2 py-3" id="page6-tab" data-toggle="pill" href="#page6"
											role="tab" aria-controls="page6" aria-selected="true">Experience Fees</a>
									</li>
									<li class="nav-item">
										<a class="nav-link px-2 py-3" id="page7-tab" data-toggle="pill" href="#page7"
											role="tab" aria-controls="page7" aria-selected="true">Tips</a>
									</li>
									<li class="nav-item">
										<a class="nav-link px-2 py-3" id="page8-tab" data-toggle="pill" href="#page8"
											role="tab" aria-controls="page8" aria-selected="true">Exchange Chips</a>
									</li>
									<li class="nav-item">
										<a class="nav-link px-2 py-3" id="page9-tab" data-toggle="pill" href="#page9"
											role="tab" aria-controls="page9" aria-selected="true">Float Check</a>
									</li>
									<li class="nav-item">
										<a class="nav-link px-2 py-3" id="pageTournament-tab" data-toggle="pill"
											href="#pageTournament" role="tab" aria-controls="pageTournament"
											aria-selected="false">Tournament</a>
									</li>
									<li class="nav-item">
										<a class="nav-link px-2 py-3" id="page10-tab" data-toggle="pill" href="#page10"
											role="tab" aria-controls="page10" aria-selected="true">Check In Logs</a>
									</li>
									<li class="nav-item">
										<a class="nav-link px-2 py-3" id="page11-tab" data-toggle="pill" href="#page11"
											role="tab" aria-controls="page11" aria-selected="true">Chip Ledger</a>
									</li>
									<li class="nav-item">
										<a class="nav-link px-2 py-3" id="page12-tab" data-toggle="pill" href="#page12"
											role="tab" aria-controls="page12" aria-selected="true">Financial Ledger</a>
									</li>
								</ul>
							</div>
							<div class="card-body">
								<div class="tab-content" id="custom-tabs-two-tabContent">
									<div class="tab-pane fade active show" id="page1" role="tabpanel"
										aria-labelledby="page1-tab">
										<div class="row">
											<div class="col-md-4">
												<div class="card card-widget widget-user">
													<div class="widget-user-header bg-secondary">
														<h3 class="widget-user-username">
															{{ session_log?.user?.name }}
														</h3>
														<h5 class="widget-user-desc">
															{{ session_log?.branch?.description }}
														</h5>
													</div>
													<div class="widget-user-image">
														<img class="img-circle elevation-2" src="@/assets/logo.png"
															alt="Logo" />
													</div>
													<div class="card-body p-0 mt-5">
														<ul class="nav flex-column">
															<li class="nav-item">
																<div class="nav-link">
																	Start Time
																	<span class="float-right">
																		{{ $formatDate(session_log?.start, 'india') }}
																	</span>
																</div>
															</li>
															<li class="nav-item">
																<div class="nav-link">
																	End Time
																	<span class="float-right">
																		{{ $formatDate(session_log?.end, 'india') }}
																	</span>
																</div>
															</li>
															<li class="nav-item">
																<div class="nav-link">
																	Total Time
																	<span class="float-right">
																		{{ totalTime(session_log) }}
																	</span>
																</div>
															</li>
															<li class="nav-item">
																<div class="nav-link">
																	Deposit
																	<span class="float-right">
																		{{ deposit }}
																	</span>
																</div>
															</li>
															<li class="nav-item">
																<div class="nav-link">
																	Withdraw
																	<span class="float-right">
																		{{ withdraw }}
																	</span>
																</div>
															</li>
															<li class="nav-item">
																<div class="nav-link">
																	BuyIn
																	<span class="float-right">
																		{{ buy_in }}
																	</span>
																</div>
															</li>
															<li class="nav-item">
																<div class="nav-link">
																	CashOut
																	<span class="float-right">
																		{{ cash_out }}
																	</span>
																</div>
															</li>
															<li class="nav-item">
																<div class="nav-link">
																	Experience Fees
																	<span class="float-right">
																		{{ experience_fee }}
																	</span>
																</div>
															</li>
															<li class="nav-item">
																<div class="nav-link">
																	Tips
																	<span class="float-right">
																		{{ tip }}
																	</span>
																</div>
															</li>
															<li class="nav-item">
																<div class="nav-link">
																	Tournament
																	<span class="float-right">
																		{{ tournament_total }}
																	</span>
																</div>
															</li>
															<li class="nav-item">
																<div class="nav-link">
																	<strong>Float Chips</strong>
																	<span class="float-right">
																		<strong>{{ difference }}</strong>
																	</span>
																</div>
															</li>
															<li class="nav-item">
																<div class="nav-link">
																	Float Cash
																	<span class="float-right">
																		{{ float_cash }}
																	</span>
																</div>
															</li>
															<!-- <li class="nav-item">
                                                                <div class="nav-link">
                                                                    Credit BuyIn
                                                                    <span class="float-right">
                                                                        {{ credit_buyin }}
                                                                    </span>
                                                                </div>
                                                            </li>
															<li class="nav-item">
                                                                <div class="nav-link">
                                                                    Wallet BuyIn
                                                                    <span class="float-right">
                                                                        {{ wallet_buyin }}
                                                                    </span>
                                                                </div>
                                                            </li> -->
															<li class="nav-item">
																<div class="nav-link" style="color: green;">
																	<strong>Footfall</strong>
																	<span class="float-right">
																		<strong>{{ logs?.length }}</strong>
																	</span>
																</div>
															</li>
														</ul>
													</div>
												</div>
											</div>
											<div class="col-md-8">
												<h5 class="mb-2">Denominations</h5>
												<table
													class="table table-responsive-sm table-bordered table-striped table-sm">
													<thead>
														<tr>
															<th class="text-center align-middle">#</th>
															<th class="text-center align-middle">Chips</th>
															<th class="text-center align-middle">Open</th>
															<th class="text-center align-middle">Close</th>
															<th class="text-center align-middle">Difference</th>
															<th class="text-center align-middle">Value</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(denomination, key) in denominations" :key="key">
															<td class="text-center align-middle">{{ key + 1 }}</td>
															<td class="text-center align-middle">
																{{ denomination.denomination_name }}
															</td>
															<td class="text-center align-middle">
																{{ denomination.open }}
															</td>
															<td class="text-center align-middle">
																{{ denomination.close }}
															</td>
															<td class="text-center align-middle">
																{{ denomination.difference }}
															</td>
															<td class="text-center align-middle">
																{{ denomination.amount }}
															</td>
														</tr>
														<tr>
															<th class="text-center align-middle" colspan="2">
																Total
															</th>
															<th class="text-center align-middle">
																{{ openTotal }}
															</th>
															<th class="text-center align-middle">
																{{ closeTotal }}
															</th>
															<th class="text-center align-middle">
																{{ diffTotal }}
															</th>
															<th class="text-center align-middle">
																{{ amountTotal }}
															</th>
														</tr>
													</tbody>
												</table>
											</div>
											<div class="col-md-12">
												<h5 class="mb-2">Activities</h5>
												<table
													class="table table-responsive-sm table-bordered table-striped table-sm">
													<thead>
														<tr>
															<th class="text-center align-middle">#</th>
															<th class="text-center align-middle">User</th>
															<th class="text-center align-middle">Login Date Time</th>
															<th class="text-center align-middle">Logout Date Time</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(activity, key) in activities" :key="key">
															<td class="text-center align-middle">{{ key + 1 }}</td>
															<td class="text-center align-middle">{{ activity?.user.name
															}}
															</td>
															<td class="text-center align-middle">{{
																activity.login_date_time
															}}
															</td>
															<td class="text-center align-middle">
																{{ activity.logout_date_time }}</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
									<div class="tab-pane fade" id="page2" role="tabpanel" aria-labelledby="page2-tab">
										<table class="table table-responsive-sm table-bordered table-striped table-sm">
											<thead>
												<tr>
													<th class="text-center align-middle">#</th>
													<th class="text-center align-middle">Transaction No</th>
													<th class="text-center align-middle">Date Time</th>
													<th class="text-center align-middle">Customer</th>
													<th class="text-center align-middle">Amount</th>
													<th class="text-center align-middle">Note</th>
													<th class="text-center align-middle">Action</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(transaction, key) in buy_ins" :key="key">
													<td class="text-center align-middle">
														{{ key + 1 }}
													</td>
													<td class="text-center align-middle">
														{{ transaction.transaction_no }}
													</td>
													<td class="text-center align-middle">
														{{ $formatDate(transaction.transaction_date_time, 'india') }}
													</td>
													<td class="text-center align-middle p-1">
														<div>{{ transaction?.customer.customer_name }}</div>
														<small class="text-muted">{{
															transaction?.customer.customer_no }}</small>
													</td>
													<td class="text-center align-middle">
														{{ transaction.amount }}
													</td>
													<td class="text-center align-middle">
														{{ transaction.note }}
													</td>
													<td class="text-center align-middle">
														<button type="button" data-toggle="modal"
															data-target="#transaction"
															@click="viewTransaction(transaction)"
															class="btn btn-xs btn-outline-info">
															<i class="fas fa-eye"></i>
														</button>
													</td>
												</tr>
												<tr>
													<th class="text-center align-middle" colspan="4">
														Total
													</th>
													<th class="text-center align-middle">
														{{ buy_in }}
													</th>
													<th class="text-center align-middle"></th>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="tab-pane fade" id="page3" role="tabpanel" aria-labelledby="page3-tab">
										<table class="table table-responsive-sm table-bordered table-striped table-sm">
											<thead>
												<tr>
													<th class="text-center align-middle">#</th>
													<th class="text-center align-middle">Transaction No</th>
													<th class="text-center align-middle">Date Time</th>
													<th class="text-center align-middle">Customer</th>
													<th class="text-center align-middle">Amount</th>
													<th class="text-center align-middle">Note</th>
													<th class="text-center align-middle">Action</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(transaction, key) in cash_outs" :key="key">
													<td class="text-center align-middle">
														{{ key + 1 }}
													</td>
													<td class="text-center align-middle">
														{{ transaction.transaction_no }}
													</td>
													<td class="text-center align-middle">
														{{ $formatDate(transaction.transaction_date_time, 'india') }}
													</td>
													<td class="text-center align-middle p-1">
														<div>{{ transaction?.customer.customer_name }}</div>
														<small class="text-muted">{{
															transaction?.customer.customer_no }}</small>
													</td>
													<td class="text-center align-middle">
														{{ transaction.amount }}
													</td>
													<td class="text-center align-middle">
														{{ transaction.note }}
													</td>
													<td class="text-center align-middle">
														<button type="button" data-toggle="modal"
															data-target="#transaction"
															@click="viewTransaction(transaction)"
															class="btn btn-xs btn-outline-info">
															<i class="fas fa-eye"></i>
														</button>
													</td>
												</tr>
												<tr>
													<th class="text-center align-middle" colspan="4">
														Total
													</th>
													<th class="text-center align-middle">
														{{ cash_out }}
													</th>
													<th class="text-center align-middle"></th>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="tab-pane fade" id="page4" role="tabpanel" aria-labelledby="page4-tab">
										<div class="d-flex align-items-center flex-wrap mb-2">
											<div class="form-check mb-0" style="margin-right: 12px;"
												v-for="(payment_mode, key) in payment_modes" :key="key">
												<input class="form-check-input" type="checkbox"
													:id="'deposit_payment_' + payment_mode.payment_mode_id"
													:value="payment_mode.payment_mode_id"
													v-model="deposit_payment_mode_id" v-on:change="filterDeposits" />
												<label class="form-check-label"
													:for="'deposit_payment_' + payment_mode.payment_mode_id">
													{{ payment_mode.payment_mode }}
												</label>
											</div>
										</div>
										<table class="table table-responsive-sm table-bordered table-striped table-sm">
											<thead>
												<tr>
													<th class="text-center align-middle">#</th>
													<th class="text-center align-middle">Transaction No</th>
													<th class="text-center align-middle">Date Time</th>
													<th class="text-center align-middle">Customer</th>
													<th class="text-center align-middle">Reference Id</th>
													<th class="text-center align-middle">Payment Mode</th>
													<th class="text-center align-middle">Amount</th>
													<th class="text-center align-middle">Note</th>
													<th class="text-center align-middle"
														v-can="'sessions.reconciliation_status'"
														v-if="hasNonCashDeposits">Reconciliation</th>
													<th class="text-center align-middle" v-can="'transactions.edit'">
														Action
													</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(transaction, key) in deposits" :key="key">
													<td class="text-center align-middle">
														{{ key + 1 }}
													</td>
													<td class="text-center align-middle">
														{{ transaction.transaction_no }}
													</td>
													<td class="text-center align-middle">
														{{ $formatDate(transaction.transaction_date_time, 'india') }}
													</td>
													<td class="text-center align-middle p-1">
														<div>{{ transaction?.customer.customer_name }}</div>
														<small class="text-muted">{{
															transaction?.customer.customer_no }}</small>
													</td>
													<td class="text-center align-middle">
														{{ transaction.reference_id }}
													</td>
													<td class="text-center align-middle">
														{{ transaction?.payment_mode?.payment_mode }}
													</td>
													<td class="text-center align-middle">
														{{ transaction.amount }}
													</td>
													<td class="text-center align-middle">
														{{ transaction.note }}
													</td>
													<td class="text-center align-middle"
														v-can="'sessions.reconciliation_status'"
														v-if="hasNonCashDeposits">
														<div v-if="transaction?.payment_mode?.payment_mode !== 'Cash'"
															class="card-tools">
															<div
																class="custom-control custom-switch custom-switch-on-success custom-switch-off-danger">
																<input type="checkbox" class="custom-control-input"
																	:id="'reconcile-' + transaction.transaction_id"
																	:value="transaction.reconciliation_status"
																	v-model="transaction.reconciliation_status"
																	@change="toggleStatus(transaction)"
																	:disabled="transaction.isLoading" />
																<label class="custom-control-label"
																	:for="'reconcile-' + transaction.transaction_id"
																	:aria-label="'Reconcile transaction ' + transaction.transaction_no"></label>
															</div>
														</div>
														<span v-else></span>
													</td>
													<td class="text-center align-middle" v-can="'transactions.edit'">
														<button type="button"
															@click="editTransaction(transaction, 'Deposit')"
															class="btn btn-xs btn-outline-primary">
															<i class="fas fa-pencil-alt"></i>
														</button>
													</td>
												</tr>
												<tr>
													<th class="text-center align-middle" colspan="6">
														Total
													</th>
													<th class="text-center align-middle">
														{{ depositTotal }}
													</th>
													<th class="text-center align-middle"></th>
													<th class="text-center align-middle" v-if="hasNonCashDeposits"></th>
													<th class="text-center align-middle"></th>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="tab-pane fade" id="page5" role="tabpanel" aria-labelledby="page5-tab">
										<div class="d-flex align-items-center flex-wrap mb-2">
											<div class="form-check mb-0" style="margin-right: 12px;"
												v-for="(payment_mode, key) in payment_modes" :key="key">
												<input class="form-check-input" type="checkbox"
													:id="'withdraw_payment_' + payment_mode.payment_mode_id"
													:value="payment_mode.payment_mode_id"
													v-model="withdraw_payment_mode_id" v-on:change="filterWithdraws" />
												<label class="form-check-label"
													:for="'withdraw_payment_' + payment_mode.payment_mode_id">
													{{ payment_mode.payment_mode }}
												</label>
											</div>
										</div>
										<table class="table table-responsive-sm table-bordered table-striped table-sm">
											<thead>
												<tr>
													<th class="text-center align-middle">#</th>
													<th class="text-center align-middle">Transaction No</th>
													<th class="text-center align-middle">Date Time</th>
													<th class="text-center align-middle">Customer</th>
													<th class="text-center align-middle">Reference Id</th>
													<th class="text-center align-middle">Payment Mode</th>
													<th class="text-center align-middle">Amount</th>
													<th class="text-center align-middle">TDS</th>
													<th class="text-center align-middle">Note</th>
													<th class="text-center align-middle"
														v-can="'sessions.reconciliation_status'"
														v-if="hasNonCashWithdraws">Reconciliation</th>
													<th class="text-center align-middle" v-can="'transactions.edit'">
														Action
													</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(transaction, key) in withdraws" :key="key">
													<td class="text-center align-middle">
														{{ key + 1 }}
													</td>
													<td class="text-center align-middle">
														{{ transaction.transaction_no }}
													</td>
													<td class="text-center align-middle">
														{{ $formatDate(transaction.transaction_date_time, 'india') }}
													</td>
													<td class="text-center align-middle p-1">
														<div>{{ transaction?.customer.customer_name }}</div>
														<small class="text-muted">{{
															transaction?.customer.customer_no }}</small>
													</td>
													<td class="text-center align-middle">
														{{ transaction.reference_id }}
													</td>
													<td class="text-center align-middle">
														{{ transaction?.payment_mode?.payment_mode }}
													</td>
													<td class="text-center align-middle">
														{{ transaction.amount }}
													</td>
													<td class="text-center align-middle">
														{{ transaction.tds }}
													</td>
													<td class="text-center align-middle">
														{{ transaction.note }}
													</td>
													<td class="text-center align-middle"
														v-can="'sessions.reconciliation_status'"
														v-if="hasNonCashWithdraws">
														<div v-if="transaction?.payment_mode?.payment_mode !== 'Cash'"
															class="card-tools">
															<div
																class="custom-control custom-switch custom-switch-on-success custom-switch-off-danger">
																<input type="checkbox" class="custom-control-input"
																	:id="'reconcile-' + transaction.transaction_id"
																	v-model="transaction.reconciliation_status"
																	@change="toggleStatus(transaction)"
																	:disabled="transaction.isLoading" />
																<label class="custom-control-label"
																	:for="'reconcile-' + transaction.transaction_id"
																	:aria-label="'Reconcile transaction ' + transaction.transaction_no"></label>
															</div>
														</div>
														<span v-else></span>
													</td>
													<td class="text-center align-middle" v-can="'transactions.edit'">
														<button type="button"
															@click="editTransaction(transaction, 'Withdraw')"
															class="btn btn-xs btn-outline-primary">
															<i class="fas fa-pencil-alt"></i>
														</button>
													</td>
												</tr>
												<tr>
													<th class="text-center align-middle" colspan="6">
														Total
													</th>
													<th class="text-center align-middle">
														{{ withdrawTotal }}
													</th>
													<th class="text-center align-middle"></th>
													<th class="text-center align-middle"></th>
													<th class="text-center align-middle" v-if="hasNonCashWithdraws">
													</th>
													<th class="text-center align-middle"></th>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="tab-pane fade" id="page6" role="tabpanel" aria-labelledby="page6-tab">
										<table class="table table-responsive-sm table-bordered table-striped table-sm">
											<thead>
												<tr>
													<th class="text-center align-middle">#</th>
													<th class="text-center align-middle">Date Time</th>
													<th class="text-center align-middle">Cashier</th>
													<th class="text-center align-middle">Table</th>
													<th class="text-center align-middle">Amount</th>
													<th class="text-center align-middle">Action</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(session, key) in experience_fees" :key="key">
													<td class="text-center align-middle">
														{{ key + 1 }}
													</td>
													<td class="text-center align-middle">
														{{ $formatDate(session.session_date + ' ' +
															session.session_time, 'india') }}
													</td>
													<td class="text-center align-middle">
														{{ session?.user.name }}
													</td>
													<td class="text-center align-middle">
														{{ session?.table.table }}
													</td>
													<td class="text-center align-middle">
														{{ session.amount == 0 ?
															sumOfSession(session.session_denominations) :
															session.amount }}
													</td>
													<td class="text-center align-middle">
														<button type="button" data-toggle="modal" data-target="#session"
															@click="viewSession(session)"
															class="btn btn-xs btn-outline-info">
															<i class="fas fa-eye"></i>
														</button>
													</td>
												</tr>
												<!-- <tr>
                                                            <th class="text-center" colspan="4">
                                                                Total
                                                            </th>
															<th class="text-center align-middle">
                                                                {{ experience_fee }}
                                                            </th>
                                                            <th></th>
                                                        </tr> -->
											</tbody>
										</table>
									</div>
									<div class="tab-pane fade" id="page7" role="tabpanel" aria-labelledby="page7-tab">
										<div class="row">
											<div class="col-sm-6">
												<div class="form-group">
													<label for="user_id">Cashier *</label>
													<select class="form-control form-control-sm"
														:class="{ 'is-invalid': errors.user_id }" v-model="meta.user_id"
														@change="filterTips">
														<option value="">Select Cashier</option>
														<option v-for="(employee, key) in employees" :key="key"
															:value="employee.user_id">{{ employee.name }}
														</option>
													</select>
												</div>
											</div>
											<div class="col-sm-6">
												<div class="form-group">
													<label for="dealer_id">Employee *</label>
													<select class="form-control form-control-sm"
														:class="{ 'is-invalid': errors.dealer_id }"
														v-model="meta.dealer_id" @change="filterTips">
														<option value="">Select Employee</option>
														<option v-for="(employee, key) in employees" :key="key"
															:value="employee.user_id">{{ employee.name }}
														</option>
													</select>
												</div>
											</div>
										</div>
										<table class="table table-responsive-sm table-bordered table-striped table-sm">
											<thead>
												<tr>
													<th class="text-center align-middle">#</th>
													<th class="text-center align-middle">Date Time</th>
													<th class="text-center align-middle">Cashier</th>
													<th class="text-center align-middle">Employee</th>
													<th class="text-center align-middle">Amount</th>
													<th class="text-center align-middle">Action</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(session, key) in tips" :key="key">
													<td class="text-center align-middle">
														{{ key + 1 }}
													</td>
													<td class="text-center align-middle">
														{{ $formatDate(session.session_date + ' ' +
															session.session_time, 'india') }}
													</td>
													<td class="text-center align-middle">
														{{ session?.user?.name }}
													</td>
													<td v-if="session.dealer_id" class="text-center align-middle">
														{{ session?.dealer?.name }}
													</td>
													<td v-if="session.employee_id" class="text-center align-middle">
														{{ session?.employee?.name }}
													</td>
													<td class="text-center align-middle">
														{{ session.amount = session.amount == 0 ?
															sumOfSession(session.session_denominations) :
															session.amount }}
													</td>
													<td class="text-center align-middle">
														<button type="button" data-toggle="modal" data-target="#session"
															@click="viewSession(session)"
															class="btn btn-xs btn-outline-info">
															<i class="fas fa-eye"></i>
														</button>
													</td>
												</tr>
												<tr>
													<th class="text-center align-middle" colspan="4">
														Total
													</th>
													<th class="text-center align-middle">
														{{ tipTotal }}
													</th>
													<th class="text-center align-middle"></th>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="tab-pane fade" id="page8" role="tabpanel" aria-labelledby="page8-tab">
										<table class="table table-responsive-sm table-bordered table-striped table-sm">
											<thead>
												<tr>
													<th class="text-center align-middle">#</th>
													<th class="text-center align-middle">Date Time</th>
													<th class="text-center align-middle">Cashier</th>
													<th class="text-center align-middle">Amount</th>
													<th class="text-center align-middle">Action</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(session, key) in exchange_chips" :key="key">
													<td class="text-center align-middle">
														{{ key + 1 }}
													</td>
													<td class="text-center align-middle">
														{{ $formatDate(session.session_date + ' ' +
															session.session_time, 'india') }}
													</td>
													<td class="text-center align-middle">
														{{ session?.user.name }}
													</td>
													<td class="text-center align-middle">
														{{ sumOfSession(session.session_denominations) }}
													</td>
													<td class="text-center align-middle">
														<button type="button" data-toggle="modal"
															data-target="#exchange" @click="viewSession(session)"
															class="btn btn-xs btn-outline-info">
															<i class="fas fa-eye"></i>
														</button>
													</td>
												</tr>
												<tr>
													<th class="text-center align-middle" colspan="3">
														Total
													</th>
													<th class="text-center align-middle">
														{{ exchange_chip }}
													</th>
													<th class="text-center align-middle"></th>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="tab-pane fade" id="page9" role="tabpanel" aria-labelledby="page9-tab">
										<table class="table table-responsive-sm table-bordered table-striped table-sm">
											<thead>
												<tr>
													<th class="text-center align-middle">#</th>
													<th class="text-center align-middle">Date Time</th>
													<th class="text-center align-middle">Cashier</th>
													<th class="text-center align-middle">Amount</th>
													<th class="text-center align-middle">Action</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(session, key) in floats" :key="key">
													<td class="text-center align-middle">
														{{ key + 1 }}
													</td>
													<td class="text-center align-middle">
														{{ $formatDate(session.session_date + ' ' +
															session.session_time, 'india') }}
													</td>
													<td class="text-center align-middle">
														{{ session?.user.name }}
													</td>
													<td class="text-center align-middle">
														{{ sumOfSession(session.session_denominations) }}
													</td>
													<td class="text-center align-middle">
														<button type="button" data-toggle="modal"
															data-target="#floatCheck" @click="viewSession(session)"
															class="btn btn-xs btn-outline-info">
															<i class="fas fa-eye"></i>
														</button>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="tab-pane fade" id="pageTournament" role="tabpanel"
										aria-labelledby="pageTournament-tab">
										<table class="table table-responsive-sm table-bordered table-striped table-sm">
											<thead>
												<tr>
													<th class="text-center align-middle">#</th>
													<th class="text-center align-middle">Date Time</th>
													<th class="text-center align-middle">Receipt No</th>
													<th class="text-center align-middle">Event</th>
													<th class="text-center align-middle">Cashier</th>
													<th class="text-center align-middle">Customer</th>
													<th class="text-center align-middle">Table</th>
													<th class="text-center align-middle">Seat</th>
													<th class="text-center align-middle">Bust</th>
													<th class="text-center align-middle">Amount</th>
													<th class="text-center align-middle">Details</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(session, key) in tournaments" :key="key">
													<td class="text-center align-middle">{{ key + 1 }}</td>
													<td class="text-center align-middle">
														{{ $formatDate(session.session_date + ' ' +
															session.session_time,
														'india') }}
													</td>
													<td class="text-center align-middle">{{ session?.receipt_no || '—' }}</td>
													<td class="text-center align-middle">{{ session?.tournament_event?.title || '—' }}</td>
													<td class="text-center align-middle">{{ session?.user?.name }}</td>
													<td class="text-center align-middle p-1">
														<div>{{ session?.customer?.customer_name }}</div>
														<small class="text-muted">{{ session?.customer?.customer_no
															}}</small>
													</td>
													<td class="text-center align-middle">{{ session?.table?.table }}
													</td>
													<td class="text-center align-middle">
														<span
															v-if="session.seat_no != null && session.seat_no !== ''">Seat
															{{ session.seat_no }}</span>
														<span v-else>—</span>
													</td>
													<td class="text-center align-middle">
														<span :class="session?.is_busted ? 'text-danger' : 'text-success'">
															{{ session?.is_busted ? 'Busted' : 'Running' }}
														</span>
													</td>
													<td class="text-center align-middle">{{ session.amount }}</td>
													<td class="text-center align-middle">
														<button type="button" class="btn btn-xs btn-outline-info"
															data-toggle="modal" data-target="#tournamentSession"
															@click="viewTournamentSession(session)">
															<i class="fas fa-eye"></i>
														</button>
													</td>
												</tr>
												<tr v-if="!tournaments || tournaments.length === 0">
													<td class="text-center text-muted" colspan="12">No tournament entries
														for
														this session.</td>
												</tr>
												<tr>
													<th class="text-center align-middle" colspan="9">Total</th>
													<th class="text-center align-middle">{{ tournament_total }}</th>
													<th class="text-center align-middle"></th>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="tab-pane fade" id="page10" role="tabpanel" aria-labelledby="page10-tab">
										<table class="table table-responsive-sm table-bordered table-striped table-sm">
											<thead>
												<tr>
													<th class="text-center align-middle">#</th>
													<th class="text-center align-middle">Customer</th>
													<th class="text-center align-middle">Mobile No</th>
													<th class="text-center align-middle">Check-In</th>
													<th class="text-center align-middle">Check-Out</th>
													<th class="text-center align-middle">No of Hours</th>
													<th class="text-center align-middle">Security</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(log, key) in logs" :key="key">
													<td class="text-center align-middle">{{ key + 1 }}</td>
													<td class="text-center align-middle p-1">
														<div>{{ log.customer?.customer_name }}</div>
														<small class="text-muted">{{ log.customer?.customer_no
														}}</small>
													</td>
													<td class="text-center align-middle">{{
														$mask(log.customer?.mobile_no) }}</td>
													<td class="text-center align-middle">{{
														$formatDate(log.start_date_time, 'india')
													}}</td>
													<td class="text-center align-middle">{{
														$formatDate(log.end_date_time, 'india')
													}}</td>
													<td class="text-center align-middle">{{
														calculateDifference(log.start_date_time,
															log.end_date_time)
													}}</td>
													<td class="text-center align-middle">{{ log.start_user?.name }}</td>
												</tr>
											</tbody>
										</table>
										<table
											class="table table-responsive-sm table-bordered table-striped table-sm mt-3">
											<thead>
												<tr>
													<th class="text-center align-middle">#</th>
													<th class="text-center align-middle">Employee ID</th>
													<th class="text-center align-middle">Employee Name</th>
													<th class="text-center align-middle">Mobile No</th>
													<th class="text-center align-middle">Check-In</th>
													<th class="text-center align-middle">Check-Out</th>
													<th class="text-center align-middle">No of Hours</th>
													<th class="text-center align-middle">Security</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(log, key) in employee_logs" :key="key">
													<td class="text-center align-middle">{{ key + 1 }}</td>
													<td class="text-center align-middle">{{ log.user?.user_id }}</td>
													<td class="text-center align-middle">{{ log.user?.name }}</td>
													<td class="text-center align-middle">{{ $mask(log.user?.mobile_no)
													}}</td>
													<td class="text-center align-middle">{{
														$formatDate(log.start_date_time, 'india')
													}}</td>
													<td class="text-center align-middle">{{
														$formatDate(log.end_date_time, 'india')
													}}</td>
													<td class="text-center align-middle">{{
														calculateDifference(log.start_date_time,
															log.end_date_time)
													}}</td>
													<td class="text-center align-middle">{{ log.start_user?.name }}</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="tab-pane fade" id="page11" role="tabpanel" aria-labelledby="page11-tab">
										<table class="table table-responsive-sm table-bordered table-striped table-sm">
											<thead>
												<tr>
													<th class="text-center align-middle">#</th>
													<th class="text-center align-middle">Transaction No</th>
													<th class="text-center align-middle">Transaction Date</th>
													<th class="text-center align-middle">Customer</th>
													<th class="text-center align-middle">BuyIn</th>
													<th class="text-center align-middle">CashOut</th>
													<th class="text-center align-middle">Balance</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(chip_ledger, key) in chipLedgersWithBalance" :key="key">
													<td class="text-center align-middle">{{ key + 1 }}</td>
													<td class="text-center align-middle">
														<a href="#" data-toggle="modal" data-target="#transaction"
															@click.prevent="viewTransaction(chip_ledger)">
															{{ chip_ledger.transaction_no }}
														</a>
													</td>
													<td class="text-center align-middle">{{
														$formatDate(chip_ledger.transaction_date_time,
															'india') }}
													</td>
													<td class="text-center align-middle p-1">
														<div>{{ chip_ledger.customer?.customer_name }}</div>
														<small class="text-muted">{{
															chip_ledger.customer?.customer_no }}</small>
													</td>
													<td class="text-center align-middle">
														{{ chip_ledger.transaction_type == 'BuyIn' ?
															chip_ledger.amount : '' }}
													</td>
													<td class="text-center align-middle">
														{{ chip_ledger.transaction_type == 'CashOut' ?
															chip_ledger.amount : '' }}
													</td>
													<td class="text-center align-middle">
														{{ chip_ledger.running_balance }}
													</td>
												</tr>
												<tr>
													<th colspan="4" class="text-center align-middle">Total</th>
													<th class="text-center align-middle">{{ buy_in }}</th>
													<th class="text-center align-middle">{{ cash_out }}</th>
													<th class="text-center align-middle">{{ cash_out - buy_in }}</th>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="tab-pane fade" id="page12" role="tabpanel" aria-labelledby="page12-tab">
										<div class="d-flex align-items-center flex-nowrap mb-2">
											<Customer :initialize="financial_ledger_customer_name"
												@selectCustomer="selectFinancialLedgerCustomer"
												style="min-width: 200px; margin-right: 20px; flex-shrink: 0;" />
											<div class="d-flex align-items-center flex-wrap" style="flex: 1;">
												<div class="form-check mb-0"
													style="margin-right: 12px; white-space: nowrap;"
													v-for="(payment_mode, key) in payment_modes" :key="key">
													<input class="form-check-input" type="checkbox"
														:id="'financial_payment_' + payment_mode.payment_mode_id"
														:value="payment_mode.payment_mode_id"
														v-model="financial_ledger_payment_mode_id" />
													<label class="form-check-label"
														:for="'financial_payment_' + payment_mode.payment_mode_id">
														{{ payment_mode.payment_mode }}
													</label>
												</div>
											</div>
											<button type="button" class="btn btn-sm btn-secondary"
												style="white-space: nowrap; flex-shrink: 0;"
												@click="resetFinancialLedgerFilters">
												Reset
											</button>
										</div>
										<table class="table table-responsive-sm table-bordered table-striped table-sm">
											<thead>
												<tr>
													<th class="text-center align-middle">#</th>
													<th class="text-center align-middle">Transaction No</th>
													<th class="text-center align-middle">Transaction Date</th>
													<th class="text-center align-middle">Customer</th>
													<th class="text-center align-middle">Payment Mode</th>
													<th class="text-center align-middle">Deposit</th>
													<th class="text-center align-middle">Withdraw</th>
													<th class="text-center align-middle">Balance</th>
													<th class="text-center align-middle">Ref No</th>
													<th class="text-center align-middle">Note</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(financial_ledger, key) in filteredFinancialLedgers"
													:key="key">
													<td class="text-center align-middle">{{ key + 1 }}</td>
													<td class="text-center align-middle">{{
														financial_ledger.transaction_no }}</td>
													<td class="text-center align-middle">{{
														$formatDate(financial_ledger.transaction_date_time,
															'india') }}
													</td>
													<td class="text-center align-middle p-1">
														<div>{{ financial_ledger.customer?.customer_name }}
														</div>
														<small class="text-muted">{{
															financial_ledger.customer?.customer_no }}</small>
													</td>
													<td class="text-center align-middle">{{
														financial_ledger.payment_mode?.payment_mode }}</td>
													<td class="text-center align-middle">
														{{ financial_ledger.transaction_type == 'Deposit' ?
															financial_ledger.amount : '' }}
													</td>
													<td class="text-center align-middle">
														{{ financial_ledger.transaction_type == 'Withdraw' ?
															financial_ledger.amount : '' }}
													</td>
													<td class="text-center align-middle">
														{{ financial_ledger.running_balance }}
													</td>
													<td class="text-center align-middle">{{
														financial_ledger.reference_id }}</td>
													<td class="text-center align-middle">{{ financial_ledger.note }}
													</td>
												</tr>
												<tr>
													<th colspan="5" class="text-center align-middle">Total</th>
													<th class="text-center align-middle">{{
														filteredFinancialDepositTotal }}
													</th>
													<th class="text-center align-middle">{{
														filteredFinancialWithdrawTotal }}
													</th>
													<th class="text-center align-middle">{{
														filteredFinancialDepositTotal -
														filteredFinancialWithdrawTotal }}</th>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<div class="modal fade" id="transaction">
			<div class="modal-dialog">
				<div class="modal-content" v-if="transaction">
					<div class="modal-header">
						<h5 class="modal-title">
							{{ transaction.transaction_type }} : {{ transaction.transaction_no }}
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="table-responsive text-nowrap">
							<table class="table table-responsive-sm table-bordered table-striped table-sm">
								<thead>
									<tr>
										<th class="text-center align-middle">#</th>
										<th class="text-center align-middle">Chips</th>
										<th class="text-center align-middle">Quantity</th>
										<th class="text-center align-middle">Amount</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(transaction_denomination, key) in transaction.transaction_denominations"
										:key="key">
										<td class="text-center align-middle">
											{{ key + 1 }}
										</td>
										<td class="text-center align-middle">
											{{ transaction_denomination?.denomination.denomination_name }}
										</td>
										<td class="text-center align-middle">
											{{ transaction_denomination.quantity }}
										</td>
										<td class="text-center align-middle">
											{{ transaction_denomination?.denomination.denomination_value *
												transaction_denomination.quantity }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="session">
			<div class="modal-dialog">
				<div class="modal-content" v-if="session">
					<div class="modal-header">
						<h5 class="modal-title">
							{{ session.session_type }}
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="table-responsive text-nowrap">
							<table class="table table-responsive-sm table-bordered table-striped table-sm">
								<thead>
									<tr>
										<th class="text-center align-middle">#</th>
										<th class="text-center align-middle">Chips</th>
										<th class="text-center align-middle">Quantity</th>
										<th class="text-center align-middle">Amount</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(session_denomination, key) in session.session_denominations" :key="key">
										<td class="text-center align-middle">
											{{ key + 1 }}
										</td>
										<td class="text-center align-middle">
											{{ session_denomination?.denomination.denomination_name }}
										</td>
										<td class="text-center align-middle">
											{{ session_denomination.quantity }}
										</td>
										<td class="text-center align-middle">
											{{ session_denomination?.denomination.denomination_value *
												session_denomination.quantity }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="exchange">
			<div class="modal-dialog">
				<div class="modal-content" v-if="session">
					<div class="modal-header">
						<h5 class="modal-title">
							{{ session.session_type }}
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="table-responsive text-nowrap">
							<table class="table table-responsive-sm table-bordered table-striped table-sm">
								<thead>
									<tr>
										<th class="text-center align-middle">#</th>
										<th class="text-center align-middle">Chips</th>
										<th class="text-center align-middle">Inward</th>
										<th class="text-center align-middle">Chips</th>
										<th class="text-center align-middle">Outword</th>
										<th class="text-center align-middle">Amount</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(session_denomination, key) in session.session_denominations" :key="key">
										<td class="text-center align-middle">
											{{ key + 1 }}
										</td>
										<td class="text-center align-middle">
											{{ session_denomination?.denomination?.denomination_name }}
										</td>
										<td class="text-center align-middle">
											{{ session_denomination.quantity }}
										</td>
										<td class="text-center align-middle">
											{{ session_denomination?.to_denomination?.denomination_name }}
										</td>
										<td class="text-center align-middle">
											{{ session_denomination.to_quantity }}
										</td>
										<td class="text-center align-middle">
											{{ session_denomination?.denomination.denomination_value *
												session_denomination.quantity }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="floatCheck">
			<div class="modal-dialog">
				<div class="modal-content" v-if="session">
					<div class="modal-header">
						<h5 class="modal-title">
							{{ session.session_type }}
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="table-responsive text-nowrap">
							<table class="table table-responsive-sm table-bordered table-striped table-sm">
								<thead>
									<tr>
										<th class="text-center align-middle">#</th>
										<th class="text-center align-middle">Denomination</th>
										<th class="text-center align-middle">System</th>
										<th class="text-center align-middle">Manual</th>
										<th class="text-center align-middle">Difference</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(session_denomination, key) in session.session_denominations" :key="key">
										<td class="text-center align-middle">
											{{ key + 1 }}
										</td>
										<td class="text-center align-middle">
											{{ session_denomination?.denomination?.denomination_name }}
										</td>
										<td class="text-center align-middle">
											{{ session_denomination.quantity }}
										</td>
										<td class="text-center align-middle">
											{{ session_denomination.to_quantity }}
										</td>
										<td class="text-center align-middle">
											{{ session_denomination.quantity - session_denomination.to_quantity }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="tournamentSession">
			<div class="modal-dialog">
				<div class="modal-content" v-if="tournament_session">
					<div class="modal-header">
						<h5 class="modal-title">Tournament</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<dl class="row mb-0 small">
							<dt class="col-sm-4">Date / time</dt>
							<dd class="col-sm-8">
								{{ $formatDate(tournament_session.session_date + ' ' + tournament_session.session_time,
									'india') }}
							</dd>
							<dt class="col-sm-4">Cashier</dt>
							<dd class="col-sm-8">{{ tournament_session?.user?.name || '—' }}</dd>
							<dt class="col-sm-4">Event</dt>
							<dd class="col-sm-8">{{ tournament_session?.tournament_event?.title || '—' }}</dd>
							<dt class="col-sm-4">Customer</dt>
							<dd class="col-sm-8">
								{{ tournament_session?.customer?.customer_name || '—' }}
								<span v-if="tournament_session?.customer?.customer_no" class="text-muted"> ({{
									tournament_session.customer.customer_no }})</span>
							</dd>
							<dt class="col-sm-4">Table</dt>
							<dd class="col-sm-8">{{ tournament_session?.table?.table || '—' }}</dd>
							<dt class="col-sm-4">Seat</dt>
							<dd class="col-sm-8">
								<span
									v-if="tournament_session.seat_no != null && tournament_session.seat_no !== ''">Seat
									{{ tournament_session.seat_no }}</span>
								<span v-else>—</span>
							</dd>
							<dt class="col-sm-4">Status</dt>
							<dd class="col-sm-8">
								<span :class="tournament_session?.is_busted ? 'text-danger' : 'text-success'">
									{{ tournament_session?.is_busted ? 'Busted' : 'Running' }}
								</span>
							</dd>
							<dt class="col-sm-4">Amount</dt>
							<dd class="col-sm-8">{{ tournament_session.amount }}</dd>
							<dt class="col-sm-4">Note</dt>
							<dd class="col-sm-8">{{ tournament_session.note || '—' }}</dd>
						</dl>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="editTransaction" ref="editTransactionModal">
			<div class="modal-dialog">
				<div class="modal-content" v-if="edit_transaction">
					<div class="modal-header">
						<h5 class="modal-title">
							Edit {{ edit_transaction_type }} : {{ edit_transaction.transaction_no }}
						</h5>
						<button type="button" class="close" @click="closeEditModal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<label for="edit_payment_mode">Payment Mode *</label>
							<select class="form-control form-control-sm"
								:class="{ 'is-invalid': edit_errors.payment_mode_id }"
								v-model="edit_transaction.payment_mode_id" id="edit_payment_mode">
								<option value="">Select Payment Mode</option>
								<option v-for="(payment_mode, key) in payment_modes" :key="key"
									:value="payment_mode.payment_mode_id">
									{{ payment_mode.payment_mode }}
								</option>
							</select>
							<div v-if="edit_errors.payment_mode_id" class="invalid-feedback">
								{{ edit_errors.payment_mode_id[0] }}
							</div>
						</div>
						<div class="form-group">
							<label for="edit_reference_id">Reference ID</label>
							<input type="text" class="form-control form-control-sm"
								:class="{ 'is-invalid': edit_errors.reference_id }"
								v-model="edit_transaction.reference_id" id="edit_reference_id"
								placeholder="Enter Reference ID" />
							<div v-if="edit_errors.reference_id" class="invalid-feedback">
								{{ edit_errors.reference_id[0] }}
							</div>
						</div>
						<div class="form-group">
							<label for="edit_note">Note</label>
							<textarea class="form-control form-control-sm" :class="{ 'is-invalid': edit_errors.note }"
								v-model="edit_transaction.note" id="edit_note" rows="3"
								placeholder="Enter Note"></textarea>
							<div v-if="edit_errors.note" class="invalid-feedback">
								{{ edit_errors.note[0] }}
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary btn-sm" @click="closeEditModal">Cancel</button>
						<button type="button" class="btn btn-primary btn-sm" @click="updateTransaction"
							:disabled="edit_transaction.isUpdating">
							<span v-if="edit_transaction.isUpdating">
								<i class="fas fa-spinner fa-spin"></i> Updating...
							</span>
							<span v-else>Update</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment";
import Customer from "@/components/Customer.vue";
import * as XLSX from "xlsx-js-style";

export default {
	name: "Report",
	components: {
		Customer
	},
	data() {
		return {
			meta: {
				branch_id: this.$store.getters.user.branch_id,
				dealer_id: '',
				user_id: '',
			},
			report: {
				branch_id: this.$store.getters.user.branch_id,
				session_log_id: '',
			},
			transaction: {},
			session: {},
			session_log: {},
			session_logs: [],
			denominations: [],
			activities: [],
			deposit: 0,
			withdraw: 0,
			buy_in: 0,
			cash_out: 0,
			fee: 0,
			tip: 0,
			experience_fee: 0,
			exchange_chip: 0,
			difference: 0,
			float_cash: 0,
			credit_buyin: 0,
			wallet_buyin: 0,
			buy_ins: [],
			cash_outs: [],
			deposits: [],
			withdraws: [],
			tips: [],
			filter_tips: [],
			experience_fees: [],
			exchange_chips: [],
			floats: [],
			tournament_total: 0,
			tournaments: [],
			tournament_session: null,
			errors: [],
			employees: [],
			logs: [],
			employee_logs: [],
			chip_ledgers: [],
			financial_ledgers: [],
			payment_modes: [],
			payment_mode_id: '',
			filter_deposits: [],
			filter_withdraws: [],
			deposit_payment_mode_id: [],
			withdraw_payment_mode_id: [],
			financial_ledger_customer_id: '',
			financial_ledger_customer_name: '',
			financial_ledger_payment_mode_id: [],
			edit_transaction: {},
			edit_transaction_type: '',
			edit_errors: {},
		};
	},

	mounted() {
		let vm = this;
		vm.getPaymentModes();
		vm.getSessionLogs();
	},

	computed: {
		openTotal: function () {
			return this.denominations.reduce((prev, cur) => +prev + +cur.open, 0);
		},
		closeTotal: function () {
			return this.denominations.reduce((prev, cur) => +prev + +cur.close, 0);
		},
		diffTotal: function () {
			return this.denominations.reduce((prev, cur) => +prev + +cur.difference, 0);
		},
		amountTotal: function () {
			return this.denominations.reduce((prev, cur) => +prev + +cur.amount, 0);
		},
		tipTotal: function () {
			return this.tips.reduce((prev, cur) => +prev + +cur.amount, 0);
		},
		depositTotal: function () {
			return this.deposits.reduce((prev, cur) => +prev + +cur.amount, 0);
		},
		withdrawTotal: function () {
			return this.withdraws.reduce((total, tx) => {
				return total + Number(tx.amount);
			}, 0);
		},
		chipLedgersWithBalance() {
			let balance = 0;
			return this.chip_ledgers.map((ledger) => {
				if (ledger.transaction_type === 'BuyIn') {
					balance -= ledger.amount;
				} else if (ledger.transaction_type === 'CashOut') {
					balance += ledger.amount;
				}
				return {
					...ledger,
					running_balance: balance,
				};
			});
		},
		hasNonCashWithdraws() {
			return this.filter_withdraws.some(transaction =>
				transaction?.payment_mode?.payment_mode !== 'Cash'
			);
		},
		hasNonCashDeposits() {
			return this.filter_deposits.some(transaction =>
				transaction?.payment_mode?.payment_mode !== 'Cash'
			);
		},

		financialLedgersWithBalance() {
			let balance = 0;
			return this.financial_ledgers.map((ledger) => {
				if (ledger.transaction_type === 'Deposit') {
					balance += ledger.amount;
				} else if (ledger.transaction_type === 'Withdraw') {
					balance -= ledger.amount;
				}
				return {
					...ledger,
					running_balance: balance,
				};
			});
		},
		uniqueFinancialCustomers() {
			const customersMap = new Map();
			this.financial_ledgers.forEach(ledger => {
				if (ledger.customer && ledger.customer.customer_id) {
					if (!customersMap.has(ledger.customer.customer_id)) {
						customersMap.set(ledger.customer.customer_id, ledger.customer);
					}
				}
			});
			return Array.from(customersMap.values()).sort((a, b) => {
				return (a.customer_no || '').localeCompare(b.customer_no || '');
			});
		},
		uniqueFinancialPaymentModes() {
			const paymentModesMap = new Map();
			this.financial_ledgers.forEach(ledger => {
				if (ledger.payment_mode && ledger.payment_mode.payment_mode_id) {
					if (!paymentModesMap.has(ledger.payment_mode.payment_mode_id)) {
						paymentModesMap.set(ledger.payment_mode.payment_mode_id, ledger.payment_mode);
					}
				}
			});
			return Array.from(paymentModesMap.values()).sort((a, b) => {
				return (a.payment_mode || '').localeCompare(b.payment_mode || '');
			});
		},
		filteredFinancialLedgers() {
			let filtered = this.financialLedgersWithBalance;

			if (this.financial_ledger_customer_id) {
				filtered = filtered.filter(ledger =>
					ledger.customer && ledger.customer.customer_id == this.financial_ledger_customer_id
				);
			}

			if (this.financial_ledger_payment_mode_id && this.financial_ledger_payment_mode_id.length > 0) {
				let selectedModeIds = Array.isArray(this.financial_ledger_payment_mode_id)
					? this.financial_ledger_payment_mode_id
					: [this.financial_ledger_payment_mode_id];
				filtered = filtered.filter(ledger =>
					ledger.payment_mode && selectedModeIds.includes(ledger.payment_mode.payment_mode_id)
				);
			}

			return filtered;
		},
		filteredFinancialDepositTotal() {
			return this.filteredFinancialLedgers
				.filter(ledger => ledger.transaction_type === 'Deposit')
				.reduce((total, ledger) => total + Number(ledger.amount || 0), 0);
		},
		filteredFinancialWithdrawTotal() {
			return this.filteredFinancialLedgers
				.filter(ledger => ledger.transaction_type === 'Withdraw')
				.reduce((total, ledger) => total + Number(ledger.amount || 0), 0);
		},
	},

	methods: {

		selectFinancialLedgerCustomer(event) {
			let vm = this;
			if (event.target.value) {
				vm.financial_ledger_customer_id = event.target.value.customer_id;
				vm.financial_ledger_customer_name = event.target.value.customer_no + ' - ' + event.target.value.customer_name;
			} else {
				vm.financial_ledger_customer_id = '';
				vm.financial_ledger_customer_name = '';
			}
		},
		resetFinancialLedgerFilters() {
			let vm = this;
			vm.financial_ledger_customer_id = '';
			vm.financial_ledger_customer_name = '';
			vm.financial_ledger_payment_mode_id = [];
		},

		getPaymentModes() {
			let vm = this;
			vm.$store
				.dispatch("post", {
					uri: "paymentModes",
					data: { branch_id: vm.meta.branch_id }
				})
				.then(function (response) {
					vm.payment_modes = response.data.data;
				})
				.catch(function (error) {
					vm.errors = error.response.data;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		getSessionLogs() {
			let vm = this;
			vm.$store.dispatch("post", { uri: "getSessionLogs", data: vm.report })
				.then(function (response) {
					vm.session_logs = response.data.data;
					if (vm.session_logs.length != 0) {
						vm.report.session_log_id = vm.session_logs[0].session_log_id
						vm.getSessionReport()
					}
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		getSessionReport() {
			let vm = this;
			let loader = vm.$loading.show();
			vm.$store.dispatch("post", { uri: "getSessionReport", data: vm.report })
				.then(function (response) {
					loader.hide();
					vm.session_log = response.data['session_log'];
					vm.denominations = response.data['denominations'];
					vm.activities = response.data['activities'];
					vm.deposit = response.data['deposit'];
					vm.withdraw = response.data['withdraw'];
					vm.buy_in = response.data['buy_in'];
					vm.cash_out = response.data['cash_out'];
					vm.fee = response.data['fee'];
					vm.tip = response.data['tip'];
					vm.experience_fee = response.data['experience_fee'];
					vm.exchange_chip = response.data['exchange_chip'];
					vm.difference = response.data['difference'];
					vm.float_cash = response.data['float_cash'];
					vm.credit_buyin = response.data['credit_buyin'];
					vm.wallet_buyin = response.data['wallet_buyin'];
					vm.buy_ins = response.data['buy_ins'];
					vm.cash_outs = response.data['cash_outs'];
					// vm.deposits = response.data['deposits'];
					vm.deposits = (response.data['deposits'] || []).map(transaction => ({
						...transaction,
						reconciliation_status: !!transaction.reconciliation_status,
						isLoading: false
					}));
					vm.filter_deposits = response.data['deposits'];
					vm.filter_withdraws = response.data['withdraws'];
					// vm.withdraws = response.data['withdraws'];
					vm.withdraws = (response.data['withdraws'] || []).map(transaction => ({
						...transaction,
						reconciliation_status: !!transaction.reconciliation_status,
						isLoading: false
					}));
					vm.tips = response.data['tips'];
					vm.filter_tips = response.data['tips'];
					vm.experience_fees = response.data['experience_fees'];
					vm.exchange_chips = response.data['exchange_chips'];
					vm.floats = response.data['floats'];
					vm.tournament_total = response.data['tournament_total'] ?? 0;
					vm.tournaments = response.data['tournaments'] ?? [];
					vm.logs = response.data['logs'];
					vm.employee_logs = response.data['employee_logs'];
					vm.getEmployees();
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		getEmployees() {
			let vm = this;
			let uri = { uri: "getBranchUsers", data: vm.meta };
			vm.$store.dispatch("post", uri)
				.then(function (response) {
					vm.employees = response.data.data;
					vm.combineTransactions();
				})
				.catch(function (error) {
					vm.loader.hide();
					vm.errors = error.response.data;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		// filterDeposits() {
		// 	let vm = this;
		// 	if (vm.payment_mode_id != '') {
		// 		vm.deposits = vm.filter_deposits.filter((deposit) => {
		// 			return deposit.payment_mode_id == vm.payment_mode_id;
		// 		});
		// 	}
		// 	else {
		// 		vm.deposits = vm.filter_deposits;
		// 	}
		// },

		filterDeposits() {
			let vm = this;
			if (!vm.deposit_payment_mode_id || vm.deposit_payment_mode_id.length === 0) {
				vm.deposits = vm.filter_deposits.map(transaction => ({
					...transaction,
					reconciliation_status: !!transaction.reconciliation_status,
					isLoading: false
				}));
				return;
			}
			let selectedModeIds = Array.isArray(vm.deposit_payment_mode_id) ? vm.deposit_payment_mode_id : [vm.deposit_payment_mode_id];
			vm.deposits = vm.filter_deposits.filter((transaction) => {
				return selectedModeIds.includes(transaction?.payment_mode?.payment_mode_id);
			}).map(transaction => ({
				...transaction,
				reconciliation_status: !!transaction.reconciliation_status,
				isLoading: false
			}));
		},

		filterWithdraws() {
			let vm = this;
			if (!vm.withdraw_payment_mode_id || vm.withdraw_payment_mode_id.length === 0) {
				vm.withdraws = vm.filter_withdraws.map(transaction => ({
					...transaction,
					reconciliation_status: !!transaction.reconciliation_status,
					isLoading: false
				}));
				return;
			}
			let selectedModeIds = Array.isArray(vm.withdraw_payment_mode_id) ? vm.withdraw_payment_mode_id : [vm.withdraw_payment_mode_id];
			vm.withdraws = vm.filter_withdraws.filter((transaction) => {
				return selectedModeIds.includes(transaction?.payment_mode?.payment_mode_id);
			}).map(transaction => ({
				...transaction,
				reconciliation_status: !!transaction.reconciliation_status,
				isLoading: false
			}));
		},

		filterTips() {
			let vm = this;
			if (vm.meta.dealer_id != '' && vm.meta.user_id != '') {
				vm.tips = vm.filter_tips.filter((tip) => {
					return tip.dealer_id == vm.meta.dealer_id && tip.user_id == vm.meta.user_id;
				});
			}
			else if (vm.meta.dealer_id != '') {
				vm.tips = vm.filter_tips.filter((tip) => {
					return tip.dealer_id == vm.meta.dealer_id;
				});
			}
			else if (vm.meta.user_id != '') {
				vm.tips = vm.filter_tips.filter((tip) => {
					return tip.user_id == vm.meta.user_id;
				});
			}
			else {
				vm.tips = vm.filter_tips
			}
		},

		viewTransaction(transaction) {
			this.transaction = transaction;
		},
		viewSession(session) {
			this.session = session;
		},
		viewTournamentSession(session) {
			this.tournament_session = session;
		},
		sumOfSession(session_denominations) {
			return session_denominations.reduce((prev, cur) => +prev + +cur.amount, 0);
		},
		calculateDifference(from_date, to_date) {
			if (from_date == null || to_date == null || from_date == '' || to_date == '') {
				return null;
			}
			else {
				const start = moment(from_date);
				const end = moment(to_date);
				const duration = moment.duration(end.diff(start));
				return `${duration.hours()} hr ${duration.minutes()} min`;
			}
		},

		toggleStatus(transaction) {
			let vm = this;
			let loader = vm.$loading.show();

			// Find the original transaction in filter arrays to maintain reactivity
			let originalDeposit = vm.filter_deposits.find(t => t.transaction_id === transaction.transaction_id);
			let originalWithdraw = vm.filter_withdraws.find(t => t.transaction_id === transaction.transaction_id);
			let originalTransaction = originalDeposit || originalWithdraw;

			let payload = {
				transaction_id: transaction.transaction_id,
				reconciliation_status: transaction.reconciliation_status,
			};
			let uri = { uri: "updateReconciliationStatus", data: payload };
			vm.$store
				.dispatch("post", uri)
				.then(function () {
					loader.hide();
					// Update the original transaction object to maintain reactivity
					if (originalTransaction) {
						originalTransaction.reconciliation_status = transaction.reconciliation_status;
					}
					vm.$store.dispatch(
						"success",
						"Reconciliation Status is successfully updated"
					);
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response?.data?.errors;
					vm.$store.dispatch("error", error?.response?.data?.message);
					// Revert both the filtered and original transaction
					transaction.reconciliation_status = !transaction.reconciliation_status;
					if (originalTransaction) {
						originalTransaction.reconciliation_status = !transaction.reconciliation_status;
					}
				});
		},
		totalTime(session_log) {
			if (session_log.end) {
				const start = moment(session_log.start);
				const end = moment(session_log.end);
				const duration = moment.duration(end.diff(start));
				const hours = Math.floor(duration.asHours());
				const minutes = duration.minutes();
				return `${hours} hr ${minutes} min`;
			}
			else {
				const start = moment(session_log.start);
				const end = moment();
				const duration = moment.duration(end.diff(start));
				const hours = Math.floor(duration.asHours());
				const minutes = duration.minutes();
				return `${hours} hr ${minutes} min`;
			}
		},

		combineTransactions() {
			let vm = this;
			vm.chip_ledgers = vm.buy_ins.concat(vm.cash_outs);
			vm.chip_ledgers.sort((a, b) => {
				return a.transaction_id - b.transaction_id;
			});

			vm.financial_ledgers = vm.deposits.concat(vm.withdraws);
			vm.financial_ledgers.sort((a, b) => {
				return a.transaction_id - b.transaction_id;
			});
		},

		editTransaction(transaction, type) {
			let vm = this;
			vm.edit_transaction = {
				...transaction,
				payment_mode_id: transaction?.payment_mode?.payment_mode_id || '',
				isUpdating: false
			};
			vm.edit_transaction_type = type;
			vm.edit_errors = {};

			// Show modal using ref
			vm.$nextTick(() => {
				if (vm.$refs.editTransactionModal) {
					const modalElement = vm.$refs.editTransactionModal;
					modalElement.classList.add('show');
					modalElement.style.display = 'block';
					document.body.classList.add('modal-open');
					const backdrop = document.createElement('div');
					backdrop.className = 'modal-backdrop fade show';
					backdrop.id = 'editTransactionBackdrop';
					document.body.appendChild(backdrop);
				}
			});
		},

		closeEditModal() {
			let vm = this;
			if (vm.$refs.editTransactionModal) {
				const modalElement = vm.$refs.editTransactionModal;
				modalElement.classList.remove('show');
				modalElement.style.display = 'none';
				document.body.classList.remove('modal-open');
				const backdrop = document.getElementById('editTransactionBackdrop');
				if (backdrop) {
					backdrop.remove();
				}
			}
		},

		updateTransaction() {
			let vm = this;
			vm.edit_transaction.isUpdating = true;
			vm.edit_errors = {};

			let payload = {
				transaction_id: vm.edit_transaction.transaction_id,
				payment_mode_id: vm.edit_transaction.payment_mode_id,
				reference_id: vm.edit_transaction.reference_id || '',
				note: vm.edit_transaction.note || '',
			};

			let uri = { uri: "updateTransactionPaymentMode", data: payload };
			vm.$store
				.dispatch("post", uri)
				.then(function (response) {
					vm.edit_transaction.isUpdating = false;

					// Update the transaction in the arrays
					let depositIndex = vm.deposits.findIndex(t => t.transaction_id === vm.edit_transaction.transaction_id);
					let withdrawIndex = vm.withdraws.findIndex(t => t.transaction_id === vm.edit_transaction.transaction_id);
					let filterDepositIndex = vm.filter_deposits.findIndex(t => t.transaction_id === vm.edit_transaction.transaction_id);
					let filterWithdrawIndex = vm.filter_withdraws.findIndex(t => t.transaction_id === vm.edit_transaction.transaction_id);

					if (depositIndex !== -1) {
						vm.deposits[depositIndex].payment_mode = response.data.data.payment_mode;
						vm.deposits[depositIndex].reference_id = response.data.data.reference_id;
						vm.deposits[depositIndex].note = response.data.data.note;
					}
					if (withdrawIndex !== -1) {
						vm.withdraws[withdrawIndex].payment_mode = response.data.data.payment_mode;
						vm.withdraws[withdrawIndex].reference_id = response.data.data.reference_id;
						vm.withdraws[withdrawIndex].note = response.data.data.note;
					}
					if (filterDepositIndex !== -1) {
						vm.filter_deposits[filterDepositIndex].payment_mode = response.data.data.payment_mode;
						vm.filter_deposits[filterDepositIndex].reference_id = response.data.data.reference_id;
						vm.filter_deposits[filterDepositIndex].note = response.data.data.note;
					}
					if (filterWithdrawIndex !== -1) {
						vm.filter_withdraws[filterWithdrawIndex].payment_mode = response.data.data.payment_mode;
						vm.filter_withdraws[filterWithdrawIndex].reference_id = response.data.data.reference_id;
						vm.filter_withdraws[filterWithdrawIndex].note = response.data.data.note;
					}

					// Update financial ledgers
					vm.combineTransactions();

					// Close modal
					vm.closeEditModal();
					vm.$store.dispatch("success", "Transaction updated successfully");
				})
				.catch(function (error) {
					vm.edit_transaction.isUpdating = false;
					vm.edit_errors = error.response?.data?.errors || {};
					vm.$store.dispatch("error", error.response?.data?.message || "Failed to update transaction");
				});
		},

		// Helper function to create styled header cell
		createHeaderCell(value) {
			return {
				v: value,
				t: 's',
				s: {
					font: { bold: true, color: { rgb: "FFFFFF" }, sz: 11 },
					fill: { fgColor: { rgb: "4472C4" } },
					alignment: { horizontal: "center", vertical: "center", wrapText: true },
					border: {
						top: { style: "thin", color: { rgb: "000000" } },
						bottom: { style: "thin", color: { rgb: "000000" } },
						left: { style: "thin", color: { rgb: "000000" } },
						right: { style: "thin", color: { rgb: "000000" } }
					}
				}
			};
		},

		// Helper function to create styled title cell
		createTitleCell(value) {
			return {
				v: value,
				t: 's',
				s: {
					font: { bold: true, color: { rgb: "000000" }, sz: 14 },
					fill: { fgColor: { rgb: "D9E1F2" } },
					alignment: { horizontal: "left", vertical: "center" },
					border: {
						bottom: { style: "medium", color: { rgb: "4472C4" } }
					}
				}
			};
		},

		// Helper function to create styled data cell
		createDataCell(value, isNumber = false, isBold = false) {
			return {
				v: value,
				t: isNumber ? 'n' : 's',
				s: {
					font: { bold: isBold, sz: 10 },
					alignment: { horizontal: isNumber ? "right" : "left", vertical: "center" },
					border: {
						top: { style: "thin", color: { rgb: "D9D9D9" } },
						bottom: { style: "thin", color: { rgb: "D9D9D9" } },
						left: { style: "thin", color: { rgb: "D9D9D9" } },
						right: { style: "thin", color: { rgb: "D9D9D9" } }
					},
					numFmt: isNumber ? '#,##0.00' : undefined
				}
			};
		},

		// Helper function to create styled total cell
		createTotalCell(value, isNumber = false) {
			return {
				v: value,
				t: isNumber ? 'n' : 's',
				s: {
					font: { bold: true, color: { rgb: "000000" }, sz: 11 },
					fill: { fgColor: { rgb: "E7E6E6" } },
					alignment: { horizontal: isNumber ? "right" : "center", vertical: "center" },
					border: {
						top: { style: "medium", color: { rgb: "000000" } },
						bottom: { style: "medium", color: { rgb: "000000" } },
						left: { style: "thin", color: { rgb: "000000" } },
						right: { style: "thin", color: { rgb: "000000" } }
					},
					numFmt: isNumber ? '#,##0.00' : undefined
				}
			};
		},

		// Helper function to apply column widths
		setColumnWidths(ws, widths) {
			ws['!cols'] = widths.map(w => ({ wch: w }));
		},

		// Helper function to freeze panes
		freezePanes(ws, row, col) {
			ws['!freeze'] = { xSplit: col, ySplit: row, topLeftCell: XLSX.utils.encode_cell({ r: row, c: col }), activePane: 'bottomRight', state: 'frozen' };
		},

		// Helper function to create styled transaction sheet
		createTransactionSheet(headers, data, totalRow, sheetName, widths) {
			const ws = {};
			let row = 0;

			// Title
			const titleCell = XLSX.utils.encode_cell({ r: row, c: 0 });
			ws[titleCell] = {
				v: sheetName + ' Report',
				t: 's',
				s: {
					font: { bold: true, sz: 16, color: { rgb: "1F4E78" } },
					alignment: { horizontal: "center", vertical: "center" }
				}
			};
			ws['!merges'] = [{ s: { r: row, c: 0 }, e: { r: row, c: headers.length - 1 } }];
			row++;

			// Headers
			headers.forEach((header, col) => {
				const cell = XLSX.utils.encode_cell({ r: row, c: col });
				ws[cell] = this.createHeaderCell(header);
			});
			row++;

			// Data rows
			data.forEach((rowData) => {
				rowData.forEach((cellValue, col) => {
					const isNumber = typeof cellValue === 'number';
					const cell = XLSX.utils.encode_cell({ r: row, c: col });
					if (isNumber) {
						ws[cell] = this.createDataCell(cellValue, true);
					} else {
						ws[cell] = this.createDataCell(cellValue || '');
					}
				});
				row++;
			});

			// Total row
			if (totalRow) {
				totalRow.forEach((cellValue, col) => {
					const isNumber = typeof cellValue === 'number';
					const isTotalLabel = col === 0;
					const cell = XLSX.utils.encode_cell({ r: row, c: col });
					if (isTotalLabel) {
						ws[cell] = this.createTotalCell(cellValue);
					} else if (isNumber) {
						ws[cell] = this.createTotalCell(cellValue, true);
					} else {
						ws[cell] = this.createTotalCell(cellValue || '');
					}
				});
			}

			this.setColumnWidths(ws, widths);
			this.freezePanes(ws, 1, 0);

			// Set sheet range to ensure Excel recognizes the sheet even if empty
			const range = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: row - 1, c: headers.length - 1 } });
			ws['!ref'] = range;

			return ws;
		},

		exportAllTabsToExcel() {
			let vm = this;
			let loader = vm.$loading.show();

			try {
				// Create a new workbook
				const wb = XLSX.utils.book_new();

				// 1. Summary Sheet
				const ws1 = {};
				let row = 0;

				// Title
				const titleCell = XLSX.utils.encode_cell({ r: row, c: 0 });
				ws1[titleCell] = {
					v: 'Session Summary Report',
					t: 's',
					s: {
						font: { bold: true, sz: 16, color: { rgb: "1F4E78" } },
						alignment: { horizontal: "center", vertical: "center" }
					}
				};
				ws1['!merges'] = [{ s: { r: row, c: 0 }, e: { r: row, c: 5 } }];
				row++;

				// Session Info
				const sessionInfo = [
					['User', vm.session_log?.user?.name || ''],
					['Branch', vm.session_log?.branch?.description || ''],
					['Start Time', vm.$formatDate(vm.session_log?.start, 'india') || ''],
					['End Time', vm.$formatDate(vm.session_log?.end, 'india') || ''],
					['Total Time', vm.totalTime(vm.session_log) || ''],
					['Deposit', vm.deposit || 0],
					['Withdraw', vm.withdraw || 0],
					['BuyIn', vm.buy_in || 0],
					['CashOut', vm.cash_out || 0],
					['Experience Fees', vm.experience_fee || 0],
					['Tips', vm.tip || 0],
					['Tournament', vm.tournament_total || 0],
					['Float Chips', vm.difference || 0],
					['Float Cash', vm.float_cash || 0],
					['Footfall', vm.logs?.length || 0]
				];

				sessionInfo.forEach((info, i) => {
					const labelCell = XLSX.utils.encode_cell({ r: row + i, c: 0 });
					const valueCell = XLSX.utils.encode_cell({ r: row + i, c: 1 });

					ws1[labelCell] = {
						v: info[0],
						t: 's',
						s: {
							font: { bold: true, sz: 10 },
							fill: { fgColor: { rgb: "F2F2F2" } },
							border: { right: { style: "thin", color: { rgb: "D9D9D9" } } }
						}
					};

					const isNumber = typeof info[1] === 'number';
					ws1[valueCell] = {
						v: info[1],
						t: isNumber ? 'n' : 's',
						s: {
							font: { sz: 10 },
							numFmt: (i >= 5 && i <= 14) ? '#,##0.00' : undefined
						}
					};
				});
				row += 16;

				// Denominations Title
				const denomTitleCell = XLSX.utils.encode_cell({ r: row, c: 0 });
				ws1[denomTitleCell] = vm.createTitleCell('Denominations');
				ws1['!merges'] = ws1['!merges'] || [];
				ws1['!merges'].push({ s: { r: row, c: 0 }, e: { r: row, c: 5 } });
				row++;

				// Denominations Header
				const denomHeaders = ['#', 'Chips', 'Open', 'Close', 'Difference', 'Value'];
				denomHeaders.forEach((header, col) => {
					const cell = XLSX.utils.encode_cell({ r: row, c: col });
					ws1[cell] = vm.createHeaderCell(header);
				});
				row++;

				// Denominations Data
				(vm.denominations || []).forEach((denom, idx) => {
					ws1[XLSX.utils.encode_cell({ r: row, c: 0 })] = vm.createDataCell(idx + 1, true);
					ws1[XLSX.utils.encode_cell({ r: row, c: 1 })] = vm.createDataCell(denom.denomination_name);
					ws1[XLSX.utils.encode_cell({ r: row, c: 2 })] = vm.createDataCell(denom.open, true);
					ws1[XLSX.utils.encode_cell({ r: row, c: 3 })] = vm.createDataCell(denom.close, true);
					ws1[XLSX.utils.encode_cell({ r: row, c: 4 })] = vm.createDataCell(denom.difference, true);
					ws1[XLSX.utils.encode_cell({ r: row, c: 5 })] = vm.createDataCell(denom.amount, true);
					row++;
				});

				// Denominations Total
				ws1[XLSX.utils.encode_cell({ r: row, c: 0 })] = vm.createTotalCell('Total');
				ws1[XLSX.utils.encode_cell({ r: row, c: 1 })] = vm.createTotalCell('');
				ws1[XLSX.utils.encode_cell({ r: row, c: 2 })] = vm.createTotalCell(vm.openTotal, true);
				ws1[XLSX.utils.encode_cell({ r: row, c: 3 })] = vm.createTotalCell(vm.closeTotal, true);
				ws1[XLSX.utils.encode_cell({ r: row, c: 4 })] = vm.createTotalCell(vm.diffTotal, true);
				ws1[XLSX.utils.encode_cell({ r: row, c: 5 })] = vm.createTotalCell(vm.amountTotal, true);
				row += 2;

				// Activities Title
				const activitiesTitleCell = XLSX.utils.encode_cell({ r: row, c: 0 });
				ws1[activitiesTitleCell] = vm.createTitleCell('Activities');
				ws1['!merges'] = ws1['!merges'] || [];
				ws1['!merges'].push({ s: { r: row, c: 0 }, e: { r: row, c: 3 } });
				row++;

				// Activities Header
				const activityHeaders = ['#', 'User', 'Login Date Time', 'Logout Date Time'];
				activityHeaders.forEach((header, col) => {
					const cell = XLSX.utils.encode_cell({ r: row, c: col });
					ws1[cell] = vm.createHeaderCell(header);
				});
				row++;

				// Activities Data
				(vm.activities || []).forEach((activity, idx) => {
					ws1[XLSX.utils.encode_cell({ r: row, c: 0 })] = vm.createDataCell(idx + 1, true);
					ws1[XLSX.utils.encode_cell({ r: row, c: 1 })] = vm.createDataCell(activity?.user?.name || '');
					ws1[XLSX.utils.encode_cell({ r: row, c: 2 })] = vm.createDataCell(activity.login_date_time || '');
					ws1[XLSX.utils.encode_cell({ r: row, c: 3 })] = vm.createDataCell(activity.logout_date_time || '');
					row++;
				});

				vm.setColumnWidths(ws1, [8, 25, 20, 20, 12, 15]);
				vm.freezePanes(ws1, 2, 0);
				// Set sheet range
				const maxRow = Math.max(row - 1, 1);
				ws1['!ref'] = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: maxRow, c: 5 } });
				XLSX.utils.book_append_sheet(wb, ws1, "Summary");

				// 2. BuyIn Sheet
				const buyInHeaders = ['#', 'Transaction No', 'Date Time', 'Customer', 'Customer No', 'Amount', 'Note'];
				const buyInData = (vm.buy_ins || []).map((transaction, idx) => [
					idx + 1,
					transaction.transaction_no || '',
					vm.$formatDate(transaction.transaction_date_time, 'india') || '',
					transaction?.customer?.customer_name || '',
					transaction?.customer?.customer_no || '',
					transaction.amount || 0,
					transaction.note || ''
				]);
				const buyInTotal = ['Total', '', '', '', '', vm.buy_in || 0, ''];
				const ws2 = vm.createTransactionSheet(buyInHeaders, buyInData, buyInTotal, 'BuyIn', [8, 18, 20, 25, 15, 15, 30]);
				XLSX.utils.book_append_sheet(wb, ws2, "BuyIn");

				// 3. CashOut Sheet
				const cashOutHeaders = ['#', 'Transaction No', 'Date Time', 'Customer', 'Customer No', 'Amount', 'Note'];
				const cashOutData = (vm.cash_outs || []).map((transaction, idx) => [
					idx + 1,
					transaction.transaction_no || '',
					vm.$formatDate(transaction.transaction_date_time, 'india') || '',
					transaction?.customer?.customer_name || '',
					transaction?.customer?.customer_no || '',
					transaction.amount || 0,
					transaction.note || ''
				]);
				const cashOutTotal = ['Total', '', '', '', '', vm.cash_out || 0, ''];
				const ws3 = vm.createTransactionSheet(cashOutHeaders, cashOutData, cashOutTotal, 'CashOut', [8, 18, 20, 25, 15, 15, 30]);
				XLSX.utils.book_append_sheet(wb, ws3, "CashOut");

				// 4. Deposit Sheet
				const depositHeaders = ['#', 'Transaction No', 'Date Time', 'Customer', 'Customer No', 'Reference Id', 'Payment Mode', 'Amount', 'Note', 'Reconciliation'];
				const depositData = (vm.deposits || []).map((transaction, idx) => [
					idx + 1,
					transaction.transaction_no || '',
					vm.$formatDate(transaction.transaction_date_time, 'india') || '',
					transaction?.customer?.customer_name || '',
					transaction?.customer?.customer_no || '',
					transaction.reference_id || '',
					transaction?.payment_mode?.payment_mode || '',
					transaction.amount || 0,
					transaction.note || '',
					transaction.reconciliation_status ? 'Yes' : 'No'
				]);
				const depositTotal = ['Total', '', '', '', '', '', '', vm.depositTotal || 0, '', ''];
				const ws4 = vm.createTransactionSheet(depositHeaders, depositData, depositTotal, 'Deposit', [8, 18, 20, 25, 15, 18, 15, 15, 30, 12]);
				XLSX.utils.book_append_sheet(wb, ws4, "Deposit");

				// 5. Withdraw Sheet
				const withdrawHeaders = ['#', 'Transaction No', 'Date Time', 'Customer', 'Customer No', 'Reference Id', 'Payment Mode', 'Amount', 'TDS', 'Note', 'Reconciliation'];
				const withdrawData = (vm.withdraws || []).map((transaction, idx) => [
					idx + 1,
					transaction.transaction_no || '',
					vm.$formatDate(transaction.transaction_date_time, 'india') || '',
					transaction?.customer?.customer_name || '',
					transaction?.customer?.customer_no || '',
					transaction.reference_id || '',
					transaction?.payment_mode?.payment_mode || '',
					transaction.amount || 0,
					transaction.tds || 0,
					transaction.note || '',
					transaction.reconciliation_status ? 'Yes' : 'No'
				]);
				const withdrawTotal = ['Total', '', '', '', '', '', '', vm.withdrawTotal || 0, '', '', ''];
				const ws5 = vm.createTransactionSheet(withdrawHeaders, withdrawData, withdrawTotal, 'Withdraw', [8, 18, 20, 25, 15, 18, 15, 15, 12, 30, 12]);
				XLSX.utils.book_append_sheet(wb, ws5, "Withdraw");

				// 6. Experience Fees Sheet
				const experienceFeeHeaders = ['#', 'Date Time', 'Cashier', 'Table', 'Amount'];
				const experienceFeeData = (vm.experience_fees || []).map((session, idx) => {
					const amount = session.amount == 0 ? vm.sumOfSession(session.session_denominations) : session.amount;
					return [
						idx + 1,
						vm.$formatDate(session.session_date + ' ' + session.session_time, 'india') || '',
						session?.user?.name || '',
						session?.table?.table || '',
						amount || 0
					];
				});
				const ws6 = vm.createTransactionSheet(experienceFeeHeaders, experienceFeeData, null, 'Experience Fees', [8, 20, 20, 15, 15]);
				XLSX.utils.book_append_sheet(wb, ws6, "Experience Fees");

				// 7. Tips Sheet
				const tipsHeaders = ['#', 'Date Time', 'Cashier', 'Employee', 'Amount'];
				const tipsData = (vm.tips || []).map((session, idx) => {
					const amount = session.amount == 0 ? vm.sumOfSession(session.session_denominations) : session.amount;
					return [
						idx + 1,
						vm.$formatDate(session.session_date + ' ' + session.session_time, 'india') || '',
						session?.user?.name || '',
						session?.dealer?.name || session?.employee?.name || '',
						amount || 0
					];
				});
				const tipsTotal = ['Total', '', '', '', vm.tipTotal || 0];
				const ws7 = vm.createTransactionSheet(tipsHeaders, tipsData, tipsTotal, 'Tips', [8, 20, 20, 20, 15]);
				XLSX.utils.book_append_sheet(wb, ws7, "Tips");

				// 8. Exchange Chips Sheet
				const exchangeChipHeaders = ['#', 'Date Time', 'Cashier', 'Amount'];
				const exchangeChipData = (vm.exchange_chips || []).map((session, idx) => [
					idx + 1,
					vm.$formatDate(session.session_date + ' ' + session.session_time, 'india') || '',
					session?.user?.name || '',
					vm.sumOfSession(session.session_denominations) || 0
				]);
				const exchangeChipTotal = ['Total', '', '', vm.exchange_chip || 0];
				const ws8 = vm.createTransactionSheet(exchangeChipHeaders, exchangeChipData, exchangeChipTotal, 'Exchange Chips', [8, 20, 20, 15]);
				XLSX.utils.book_append_sheet(wb, ws8, "Exchange Chips");

				// 9. Float Check Sheet
				const floatCheckHeaders = ['#', 'Date Time', 'Cashier', 'Amount'];
				const floatCheckData = (vm.floats || []).map((session, idx) => [
					idx + 1,
					vm.$formatDate(session.session_date + ' ' + session.session_time, 'india') || '',
					session?.user?.name || '',
					vm.sumOfSession(session.session_denominations) || 0
				]);
				const ws9 = vm.createTransactionSheet(floatCheckHeaders, floatCheckData, null, 'Float Check', [8, 20, 20, 15]);
				XLSX.utils.book_append_sheet(wb, ws9, "Float Check");

				const tournamentHeaders = ['#', 'Date Time', 'Receipt No', 'Event', 'Cashier', 'Customer', 'Customer No', 'Table', 'Seat', 'Bust Status', 'Amount', 'Note'];
				const tournamentData = (vm.tournaments || []).map((session, idx) => [
					idx + 1,
					vm.$formatDate(session.session_date + ' ' + session.session_time, 'india') || '',
					session?.receipt_no || '',
					session?.tournament_event?.title || '',
					session?.user?.name || '',
					session?.customer?.customer_name || '',
					session?.customer?.customer_no || '',
					session?.table?.table || '',
					session.seat_no != null && session.seat_no !== '' ? 'Seat ' + session.seat_no : '',
					session?.is_busted ? 'Busted' : 'Running',
					session.amount || 0,
					session.note || ''
				]);
				const tournamentTotalRow = ['Total', '', '', '', '', '', '', '', '', '', vm.tournament_total || 0, ''];
				const wsTournament = vm.createTransactionSheet(tournamentHeaders, tournamentData, tournamentTotalRow, 'Tournament', [8, 20, 20, 22, 18, 22, 14, 12, 10, 14, 12, 28]);
				XLSX.utils.book_append_sheet(wb, wsTournament, "Tournament");

				// 10. Check In Logs Sheet
				const ws10 = {};
				let checkInRow = 0;

				// Customer Check-In Title
				const customerTitleCell = XLSX.utils.encode_cell({ r: checkInRow, c: 0 });
				ws10[customerTitleCell] = vm.createTitleCell('Customer Check-In Logs');
				ws10['!merges'] = [{ s: { r: checkInRow, c: 0 }, e: { r: checkInRow, c: 7 } }];
				checkInRow++;

				// Customer Headers
				const customerHeaders = ['#', 'Customer', 'Customer No', 'Mobile No', 'Check-In', 'Check-Out', 'No of Hours', 'Security'];
				customerHeaders.forEach((header, col) => {
					const cell = XLSX.utils.encode_cell({ r: checkInRow, c: col });
					ws10[cell] = vm.createHeaderCell(header);
				});
				checkInRow++;

				// Customer Data
				(vm.logs || []).forEach((log, idx) => {
					ws10[XLSX.utils.encode_cell({ r: checkInRow, c: 0 })] = vm.createDataCell(idx + 1, true);
					ws10[XLSX.utils.encode_cell({ r: checkInRow, c: 1 })] = vm.createDataCell(log.customer?.customer_name || '');
					ws10[XLSX.utils.encode_cell({ r: checkInRow, c: 2 })] = vm.createDataCell(log.customer?.customer_no || '');
					ws10[XLSX.utils.encode_cell({ r: checkInRow, c: 3 })] = vm.createDataCell(vm.$mask(log.customer?.mobile_no) || '');
					ws10[XLSX.utils.encode_cell({ r: checkInRow, c: 4 })] = vm.createDataCell(vm.$formatDate(log.start_date_time, 'india') || '');
					ws10[XLSX.utils.encode_cell({ r: checkInRow, c: 5 })] = vm.createDataCell(vm.$formatDate(log.end_date_time, 'india') || '');
					ws10[XLSX.utils.encode_cell({ r: checkInRow, c: 6 })] = vm.createDataCell(vm.calculateDifference(log.start_date_time, log.end_date_time) || '');
					ws10[XLSX.utils.encode_cell({ r: checkInRow, c: 7 })] = vm.createDataCell(log.start_user?.name || '');
					checkInRow++;
				});
				checkInRow++;

				// Employee Check-In Title
				const employeeTitleCell = XLSX.utils.encode_cell({ r: checkInRow, c: 0 });
				ws10[employeeTitleCell] = vm.createTitleCell('Employee Check-In Logs');
				ws10['!merges'] = ws10['!merges'] || [];
				ws10['!merges'].push({ s: { r: checkInRow, c: 0 }, e: { r: checkInRow, c: 7 } });
				checkInRow++;

				// Employee Headers
				const employeeHeaders = ['#', 'Employee ID', 'Employee Name', 'Mobile No', 'Check-In', 'Check-Out', 'No of Hours', 'Security'];
				employeeHeaders.forEach((header, col) => {
					const cell = XLSX.utils.encode_cell({ r: checkInRow, c: col });
					ws10[cell] = vm.createHeaderCell(header);
				});
				checkInRow++;

				// Employee Data
				(vm.employee_logs || []).forEach((log, idx) => {
					ws10[XLSX.utils.encode_cell({ r: checkInRow, c: 0 })] = vm.createDataCell(idx + 1, true);
					ws10[XLSX.utils.encode_cell({ r: checkInRow, c: 1 })] = vm.createDataCell(log.user?.user_id || '');
					ws10[XLSX.utils.encode_cell({ r: checkInRow, c: 2 })] = vm.createDataCell(log.user?.name || '');
					ws10[XLSX.utils.encode_cell({ r: checkInRow, c: 3 })] = vm.createDataCell(vm.$mask(log.user?.mobile_no) || '');
					ws10[XLSX.utils.encode_cell({ r: checkInRow, c: 4 })] = vm.createDataCell(vm.$formatDate(log.start_date_time, 'india') || '');
					ws10[XLSX.utils.encode_cell({ r: checkInRow, c: 5 })] = vm.createDataCell(vm.$formatDate(log.end_date_time, 'india') || '');
					ws10[XLSX.utils.encode_cell({ r: checkInRow, c: 6 })] = vm.createDataCell(vm.calculateDifference(log.start_date_time, log.end_date_time) || '');
					ws10[XLSX.utils.encode_cell({ r: checkInRow, c: 7 })] = vm.createDataCell(log.start_user?.name || '');
					checkInRow++;
				});

				vm.setColumnWidths(ws10, [8, 25, 15, 15, 20, 20, 15, 20]);
				vm.freezePanes(ws10, 1, 0);
				// Set sheet range
				const maxCheckInRow = Math.max(checkInRow - 1, 1);
				ws10['!ref'] = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: maxCheckInRow, c: 7 } });
				XLSX.utils.book_append_sheet(wb, ws10, "Check In Logs");

				// 11. Chip Ledger Sheet
				const chipLedgerHeaders = ['#', 'Transaction No', 'Transaction Date', 'Customer', 'Customer No', 'BuyIn', 'CashOut', 'Balance'];
				const chipLedgerData = (vm.chipLedgersWithBalance || []).map((ledger, idx) => [
					idx + 1,
					ledger.transaction_no || '',
					vm.$formatDate(ledger.transaction_date_time, 'india') || '',
					ledger.customer?.customer_name || '',
					ledger.customer?.customer_no || '',
					ledger.transaction_type == 'BuyIn' ? ledger.amount : '',
					ledger.transaction_type == 'CashOut' ? ledger.amount : '',
					ledger.running_balance || 0
				]);
				const chipLedgerTotal = ['Total', '', '', '', '', vm.buy_in || 0, vm.cash_out || 0, (vm.cash_out - vm.buy_in) || 0];
				const ws11 = vm.createTransactionSheet(chipLedgerHeaders, chipLedgerData, chipLedgerTotal, 'Chip Ledger', [8, 18, 20, 25, 15, 15, 15, 15]);
				XLSX.utils.book_append_sheet(wb, ws11, "Chip Ledger");

				// 12. Financial Ledger Sheet
				const financialLedgerHeaders = ['#', 'Transaction No', 'Transaction Date', 'Customer', 'Customer No', 'Payment Mode', 'Deposit', 'Withdraw', 'Balance', 'Ref No', 'Note'];
				const financialLedgerData = (vm.filteredFinancialLedgers || []).map((ledger, idx) => [
					idx + 1,
					ledger.transaction_no || '',
					vm.$formatDate(ledger.transaction_date_time, 'india') || '',
					ledger.customer?.customer_name || '',
					ledger.customer?.customer_no || '',
					ledger.payment_mode?.payment_mode || '',
					ledger.transaction_type == 'Deposit' ? ledger.amount : '',
					ledger.transaction_type == 'Withdraw' ? ledger.amount : '',
					ledger.running_balance || 0,
					ledger.reference_id || '',
					ledger.note || ''
				]);
				const financialLedgerTotal = [
					'Total',
					'',
					'',
					'',
					'',
					'',
					vm.filteredFinancialDepositTotal || 0,
					vm.filteredFinancialWithdrawTotal || 0,
					(vm.filteredFinancialDepositTotal - vm.filteredFinancialWithdrawTotal) || 0,
					'',
					''
				];
				const ws12 = vm.createTransactionSheet(financialLedgerHeaders, financialLedgerData, financialLedgerTotal, 'Financial Ledger', [8, 18, 20, 25, 15, 15, 15, 15, 15, 18, 30]);
				XLSX.utils.book_append_sheet(wb, ws12, "Financial Ledger");

				// Generate filename
				const startDate = vm.$formatDate(vm.session_log?.start, 'india') || '';
				const endDate = vm.$formatDate(vm.session_log?.end, 'india') || '';
				const filename = `Session_Report_${startDate}_to_${endDate}.xlsx`.replace(/\//g, '-').replace(/:/g, '-');

				// Write file
				XLSX.writeFile(wb, filename);

				loader.hide();
				vm.$store.dispatch("success", "All tabs exported to Excel successfully");
			} catch (error) {
				loader.hide();
				console.error('Export error:', error);
				vm.$store.dispatch("error", "Failed to export Excel file: " + (error.message || 'Unknown error'));
			}
		}
	},
};
</script>

<style scoped>
#custom-tabs-two-tab {
	display: flex;
	flex-wrap: nowrap;
	overflow-x: auto;
	overflow-y: hidden;
	-webkit-overflow-scrolling: touch;
	scrollbar-width: thin;
}

#custom-tabs-two-tab .nav-item {
	flex: 0 0 auto;
}

#custom-tabs-two-tab .nav-link {
	white-space: nowrap;
	text-align: center;
	padding: 0.5rem 0.55rem;
	font-size: 0.8rem;
	line-height: 1.2;
	min-width: 0;
}
</style>
